import type { NavItem } from '@/app/navigation';

/**
 * Escolhe para onde o acesso leva: a tela inicial do perfil, se a pessoa a alcanca
 * pelo menu; senao o Painel; e sem Painel, o primeiro item do menu dela. Mandar
 * alguem para uma tela que recusa o acesso seria comecar o dia com um erro.
 */
export function escolherTelaInicial(
  telaDoPerfil: string | undefined,
  visiveis: NavItem[],
): string {
  const desejada = telaDoPerfil || '/';
  if (visiveis.some((item) => item.path === desejada)) return desejada;
  if (visiveis.some((item) => item.path === '/')) return '/';
  return visiveis[0]?.path ?? '/';
}
